import { LOCALSTORAGE_FILTER_PREFERENCE_KEY } from "../../../services/Constants";

export const filterCompressor = filters => {
    // Initialize an empty object to hold the compressed filter states
    const compressedFilters = {};

    // Loop through each key in the filters object
    Object.keys(filters).forEach(filterKey => {
        const filter = filters[filterKey];

        // Handle age and height differently as it's an array
        if (filterKey === 'ageFilterState'  || filterKey === 'heightFilterState') {
            compressedFilters[filterKey] = filter;
        } else {
            // If all options are selected, avoid persisting in cache
            if(filter.selectedCount === filter.filters.length)
                return;
            // Initialize an array to hold the labels of the selected filters
            const selectedFilters = [];

            // Loop through the filters array within the current filter state
            filter.filters.forEach(filterOption => {
                if (filterOption.checked) {
                    // If the filter is checked, push its label to the selectedFilters array
                    selectedFilters.push(filterOption.label);
                }
            });

            // If there are any selected filters, add them to the compressedFilters object
            if (selectedFilters.length > 0) {
                compressedFilters[filterKey] = selectedFilters;
            }
        }
    });

    // Return the compressed filter states
    return compressedFilters;
}

export const filterExpander = (baseFilters, compressedFilters) => {
    if(!compressedFilters)
        return baseFilters
    // Loop through each key in the compressedFilters object
    Object.keys(compressedFilters).forEach(filterKey => {
        var selectedFiltersOrValues = compressedFilters[filterKey];

        // Handle the ageFilterState differently as it's an array
        if (filterKey === 'ageFilterState' || filterKey === 'heightFilterState') {
            baseFilters[filterKey] = selectedFiltersOrValues;
        } else {
            var selectedCount = 0;
            // Select all initializes all the options as chhecked. We need to reset this as some filters have been explicitly applied.
            if(baseFilters[filterKey].enableSelectAll) {
                baseFilters[filterKey].filters.forEach(filter => {
                    filter.checked = false;
                })
            }
            // Assuming all other filters are in the { filterName: [selectedLabels] } format
            selectedFiltersOrValues.forEach(selectedLabel => {
                // Find the filter option in the baseFilters and set it to checked
                const filterOption = baseFilters[filterKey].filters.find(option => option.label === selectedLabel);
                if (filterOption) {
                    filterOption.checked = true;
                    selectedCount++;
                }
            });
            baseFilters[filterKey].selectedCount = selectedCount;
        }
    });

    // Return the updated baseFilters object
    return baseFilters;
}

export const cacheFilterState = (filterState) => {
    let filterPreference = JSON.stringify(filterCompressor(filterState) )
    localStorage.setItem(LOCALSTORAGE_FILTER_PREFERENCE_KEY, filterPreference);
}
